// extracted by mini-css-extract-plugin
export default {"title":"DataHubTitle_title__n6SyU"};